"use client";
import Intro from "@/ui/Intro";
import AboutIndustry from "../indusrty/Aboutindustry";
import RichTextRenderer from "@/ui/Richtextrender";

const Advantages = ({ school }) => {
    const advantageList = school?.advantageList;

    if (!advantageList) return null;

    // Convert rich text advantages to bullet points (plain text needed for AboutIndustry)
    const advantagesRaw = advantageList?.advantages;
    let advantagesText = "";

    if (Array.isArray(advantagesRaw)) {
        advantagesText = advantagesRaw
            .map(block => {
                if (block?.children && Array.isArray(block.children)) {
                    return block.children
                        .map(child => {
                            if (child.type === "text" && child.text) return child.text;
                            if (child.type === "link" && child.children?.[0]?.text) {
                                return child.children[0].text;
                            }
                            return "";
                        })
                        .join("");
                }
                return "";
            })
            .join("\n");
    } else if (typeof advantagesRaw === "string") {
        advantagesText = advantagesRaw;
    }

    const points = advantagesText
        .split("\n")
        .map((point) => point.replace(/^- /, '').trim())
        .filter(Boolean);

    // Image handling
    const advantageimage = advantageList?.advantageimage?.data?.[0]?.attributes ||
        advantageList?.advantageimage?.attributes ||
        advantageList?.advantageimage;
    const imageSrc = advantageimage?.formats?.large?.url ||
        advantageimage?.formats?.medium?.url ||
        advantageimage?.url;

    return (
        <div className="mt-14 ">
            <Intro
                className="space-y-6  mx-auto "
                title={
                    <div >
                        <RichTextRenderer
                            content={advantageList.heading}
                            className="text-2xl sm:text-3xl lg:text-[42px] font-bold "
                        />
                    </div>
                }
                description={
                    <div >
                        <RichTextRenderer
                            content={advantageList.subheading}
                            className="text-base sm:text-lg lg:text-[18px] max-w-5xl mb-8"
                        />
                    </div>
                }
            />

            {/* AboutIndustry (plain text points + rich image alt) */}
            <AboutIndustry
                points={points}
                imageSrc={imageSrc}
                imageAlt={
                    advantageList.heading?.[0]?.children?.[0]?.text ||
                    "School Advantages"
                }
            />
        </div>
    );
};

export default Advantages;
